import { Button, Col, Input, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import customerApi from '../../api/customer.api'
import orderApi from '../../api/order.api'
import productApi from '../../api/product.api'
import ProductBuyerComponent from '../../components/sales/ProductBuyerComponent'
import ProductOptionComponent from '../../components/sales/ProductOptionComponent'
import ProductPriceComponent from '../../components/sales/ProductPriceComponent'
import ProductSearchComponent from '../../components/sales/ProductSearchComponent'
import ContentHeader from '../../components/shared/ContentHeader'
import { userState } from '../../store/user'
import styles from '../../styles/sales.module.scss'

const OrderTelPage = () => {
  const IMP = window.IMP
  const IMP_UID = process.env.REACT_APP_IMP_UID ?? ''
  const navigate = useNavigate()
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(false)
  // const setIsSearchText = (value) => dispatch(setSearchText(value));

  const [searchOptions, setSearchOptions] = useState({
    productName: '',
    brandName: '',
  })
  const [selectedProductRowKeys, setSelectedProductRowKeys] = useState([])
  const [selectedProductRows, setSelectedProductRows] = useState([])
  const [orderType, setOrderType] = useState('createdAt')
  const [orderBy, setOrderBy] = useState('desc')
  const [selectedOptionRowKeys, setSelectedOptionRowKeys] = useState([])
  const [selectedOptionRows, setSelectedOptionRows] = useState([])
  const [optionList, setOptionList] = useState({
    total: [],
    except: [],
  })
  const [orderDetailList, setOrderDetailList] = useState([])
  const [orderInfo, setOrderInfo] = useState({
    totalPrice: 0,
  })
  const [selectOptions, setSelectOptions] = useState({
    sameDepositName: true,
    cashReceiptType: null,
    deliveryPrice: 0,
  })
  const [searchKeyword, setSearchKeyword] = useState('')
  const [paymentType, setPaymentType] = useState('vbank')

  const paymentTypeOption = [
    { label: '가상계좌', value: 'vbank' },
    // {label: "무통장입금", value: "deposit"},
    // {label: "카드결제", value: "card"}
  ]
  const cashReceiptTypeItems = [
    { label: '미발행', value: null },
    { label: '소득공제용', value: 'DEDUCTION' },
    { label: '지출증빙용', value: 'EXPENDITURE' },
  ]

  const optionRowSelection = {
    selectedRowKeys: selectedOptionRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      let editRows = []

      editRows = selectedRows.map((item) => ({
        ...item,
        optionId: item?.id,
        productName: item?.productName ?? selectedProductRows[0]?.productName,
        brandName: item?.brandName ?? selectedProductRows[0]?.brandName,
        sellerId: item?.sellerId ?? selectedProductRows[0]?.sellerId,
        sellerName: item?.sellerName ?? selectedProductRows[0]?.sellerName,
        savingPointType:
          item?.savingPointType ?? selectedProductRows[0].savingPointType,
        savingPoint: item?.savingPoint ?? selectedProductRows[0]?.savingPoint,
      }))
      editRows = [...selectedOptionRows, ...editRows]

      const filteredList = editRows.reduce((prev, curr) => {
        const findData = prev.find((item) => item.id === curr.id)
        if (!findData) {
          return prev.concat([curr])
        } else {
          return prev
        }
      }, [])

      setSelectedOptionRowKeys(selectedRowKeys)
      setSelectedOptionRows(filteredList)
    },
  }

  const [sellerList, setSellerList] = useState([])

  useEffect(() => {
    if (user) {
      getSellerList()
    }
  }, [user, orderType, orderBy])

  useEffect(() => {
    readProductOptions()
  }, [selectedProductRowKeys])

  useEffect(() => {
    if (
      Object.keys(optionList)?.length > 0 &&
      selectedOptionRows?.length === 1 &&
      optionList.total &&
      optionList?.total?.length > 0
    ) {
      if (optionList.total[0]?.id === selectedOptionRows[0]?.id) {
        if (optionList.total[0].quantity === 1) {
          setSelectOptions({
            ...selectOptions,
            deliveryPrice: 0,
          })
        } else {
          setSelectOptions({
            ...selectOptions,
            deliveryPrice: 0,
          })
        }
      } else {
        setSelectOptions({
          ...selectOptions,
          deliveryPrice: 0,
        })
      }
    } else {
      setSelectOptions({
        ...selectOptions,
        deliveryPrice: 0,
      })
    }

    let currList = [...orderDetailList]
    for (let i = 0; i < currList?.length; i++) {
      for (let j = 0; j < optionList.total?.length; j++) {
        if (currList[i]?.optionId === optionList.total[j]?.id) {
          if (currList[i].quantity !== optionList.total[j].quantity) {
            currList[i].quantity = optionList.total[j].quantity
          }
        }
      }
    }
    setOrderDetailList(currList)
  }, [optionList, selectedOptionRows])

  /**
   * 판매자 리스트 가져오기
   * @returns {Promise<void>}
   */
  const getSellerList = async () => {
    setIsLoading(true)
    try {
      const res = await productApi.readSellerList(user.id)
      if (res.data.code === 200) {
        setSellerList(res.data.result)
      } else {
        alert('정상적인 요청이 아닙니다.')
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('getSellerList read error', error)
    }
  }

  /**
   * 선택 상품 옵션 api 호출
   */
  const readProductOptions = async () => {
    setIsLoading(true)
    try {
      if (selectedProductRowKeys?.length !== 0) {
        let exceptOptionList = []
        for (const orderDetail of orderDetailList) {
          if (
            orderDetail.productId === selectedProductRowKeys[0] &&
            Object.prototype.hasOwnProperty.call(orderDetail, 'optionId')
          ) {
            exceptOptionList.push(orderDetail.optionId)
          }
        }
        const param = {
          productId: selectedProductRowKeys[0],
          exceptOptions: exceptOptionList.join(','),
        }
        const res = await productApi.readProductOptionList(param, user.id)
        if (res.data.code === 200) {
          let totalList = []
          for (
            let i = 0;
            i < res.data.result.productItemOptionList?.length;
            i++
          ) {
            totalList.push({
              ...res.data.result.productItemOptionList[i],
              quantity: 1,
            })
          }
          setOptionList({
            total: totalList,
            except: res.data.result.productItemExceptOptionList,
          })
        } else {
          alert(
            '선택된 상품에 관한 옵션 정보를 불러오는데 실패하였습니다. 다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.',
          )
        }
      } else {
        setOptionList({
          total: [],
          except: [],
        })
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('readProductOptions read error', error)
      alert(error)
    }
  }

  const handleChange = async (e) => {
    const { name, value } = e.target
    if (name === 'productName' || name === 'brandName') {
      setSearchOptions({ ...searchOptions, [name]: value })
    } else if (name === 'popular') {
      setSearchOptions({ ...searchOptions, productName: value.productName })
      setSelectedProductRows([])
      setSelectedProductRowKeys([])
      setOrderDetailList([])

      const param = {
        productId: null,
        productMakerName: '',
        productName: value.productName,
        brandName: '',
        orderType: orderType,
        orderBy: orderBy,
      }
      const res = await productApi.readProductListAll(param, user.id)
      if (res.data.code === 200) {
        setIsLoading(true)
        setSelectedProductRows([res.data.result[0]])
        setSelectedProductRowKeys([res.data.result[0].productId])
        setIsLoading(false)
      }
    } else if (name === 'name') {
      if (selectOptions.sameDepositName) {
        setOrderInfo({ ...orderInfo, [name]: value, depositName: value })
      } else {
        setOrderInfo({ ...orderInfo, [name]: value })
      }
    } else if (name === 'phone') {
      let phone = value.trim()
      if (phone) {
        if (phone.includes('-')) {
          phone = phone.replaceAll('-', '')
        }
        const param = {
          phone: phone,
        }
        const res = await orderApi.getOrderOneByPhone(param, user.id)
        if (res.data.code === 200) {
          setOrderInfo({
            ...orderInfo,
            [name]: value,
            name: res.data.result.name,
            depositName: res.data.result.name,
            address: res.data.result.address,
            addressDetail: res.data.result.addressDetail,
            postalCode: res.data.result.postalCode
              ? res.data.result.postalCode
              : null,
            createdBy: res.data.result.createdBy ?? null,
          })
        } else {
          setOrderInfo({ ...orderInfo, [name]: value })
        }
      } else {
        setOrderInfo({ ...orderInfo, [name]: value })
      }
    } else if (name === 'cashReceiptType') {
      if (value === null) {
        setOrderInfo({ ...orderInfo, cashReceiptPhone: null })
      }
      setSelectOptions({ ...selectOptions, [name]: value })
    } else if (name === 'sameDepositName') {
      if (e.target.checked) {
        setOrderInfo({ ...orderInfo, depositName: orderInfo.name })
      }
      setSelectOptions({ ...selectOptions, [name]: e.target.checked })
    } else if (name === 'faq-search') {
      setSearchKeyword(value)
    } else {
      setOrderInfo({ ...orderInfo, [name]: value })
    }
  }

  /**
   * 상품 검색
   */
  const handleProductSearch = () => {
    setSelectedProductRows([])
    setSelectedProductRowKeys([])
  }

  /**
   * 검색 상품 목록 선택
   */
  const handleProductRowEvent = (record) => {
    return {
      onClick: () => {
        if (selectedProductRowKeys.includes(record.productId)) {
          setSelectedProductRowKeys([])
          setSelectedProductRows([])
          setOrderDetailList([])
        } else {
          setSelectedProductRowKeys([record.productId])
          setSelectedProductRows([record])
        }
      },
    }
  }

  const tableOnChange = (pagination, filters, sorter) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === 'descend') {
          setOrderBy('desc')
        } else if (sorter.order === 'ascend') {
          setOrderBy('asc')
        }
        setOrderType(sorter.field)
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType('createdAt')
        setOrderBy('desc')
      }
    }
  }

  /**
   * 상품 옵션 목록 선택
   */
  const handleOptionRowEvent = (record) => {
    return {
      onClick: () => {
        let editRows = []
        let editRowKeys = []
        if (selectedOptionRowKeys.includes(record.id)) {
          editRows = selectedOptionRows.filter((row) => row.id !== record.id)
          editRowKeys = selectedOptionRowKeys.filter((key) => key !== record.id)
        } else {
          editRows = [...selectedOptionRows, record]
          editRowKeys = [...selectedOptionRowKeys, record.id]
        }
        editRows = editRows.map((item) => ({
          ...item,
          optionId: item?.id,
          productName: item?.productName ?? selectedProductRows[0]?.productName,
          brandName: item?.brandName ?? selectedProductRows[0]?.brandName,
          sellerId: item?.sellerId ?? selectedProductRows[0]?.sellerId,
          sellerName: item?.sellerName ?? selectedProductRows[0]?.sellerName,
          savingPointType:
            item?.savingPointType ?? selectedProductRows[0].savingPointType,
          savingPoint: item?.savingPoint ?? selectedProductRows[0].savingPoint,
        }))
        setSelectedOptionRows(editRows)
        setSelectedOptionRowKeys(editRowKeys)
        setOrderDetailList(editRows)
      },
    }
  }

  /**
   * 취소 버튼
   */
  const cancelBtnClick = () => {
    if (
      window.confirm(
        '해당 페이지에서 나가면 지금까지 작성했던 기록들이 전부 사라집니다.\n그래도 나가시겠습니까?',
      )
    ) {
      if (window.history.length > 1) {
        navigate(-1)
      } else {
        navigate('/')
      }
    }
  }

  /**
   * 주문 생성 validation
   */
  const createOrderValidation = () => {
    if (orderDetailList?.length === 0) {
      alert('구매하시려는 상품이 선택되지 않았습니다.')
      return false
    } else if (orderInfo.name === null || orderInfo.name === '') {
      alert('주문자 정보 > 받는 분의 성함이 입력되지 않았습니다.')
      return false
    } else if (orderInfo.phone === null || orderInfo.phone === '') {
      alert('주문자 정보 > 핸드폰 번호가 입력되지 않았습니다.')
      return false
    } else if (orderInfo.phone.includes('-')) {
      alert('주문자 정보 > 핸드폰 번호 입력시 - 는 빼고 입력해주시길 바랍니다.')
      return false
    } else if (orderInfo.address === null || orderInfo.address === '') {
      alert('주문자 정보 > 배송지가 입력되지 않았습니다.')
      return false
    } else if (orderInfo.depositName === null || orderInfo.depositName === '') {
      alert('주문자 정보 > 입금자명이 입력되지 않았습니다.')
      return false
    } else if (
      selectOptions.cashReceiptType !== null &&
      (orderInfo.cashReceiptType === null || orderInfo.cashReceiptType === '')
    ) {
      alert(
        '주문자 정보 > 현금영수증을 발행할 휴대폰번호가 입력되지 않았습니다.',
      )
      return false
    } else if (
      selectOptions.cashReceiptType !== null &&
      orderInfo.cashReceiptType.includes('-')
    ) {
      alert(
        '주문자 정보 > 현금영수증을 발행할 휴대폰번호 입력시 - 는 빼고 입력해주시길 바랍니다.',
      )
      return false
    } else {
      return true
    }
  }

  /**
   * 카드 결제
   */
  const handlePurchase = async () => {
    IMP.agency(IMP_UID, 'SUG') // 하위 상점에서 SDK 초기화
    if (paymentType !== 'vbank') {
      // IamPortBilling()
    } else {
      const valid = createOrderValidation() // validation check
      if (
        valid &&
        window.confirm(`아래의 정보들로 주문을 생성합니다. 기입하신 정보가 맞는지 다시 한번 확인해주시길 바랍니다.\n
            ■ 주문정보
            □ 제품명 : ${selectedOptionRows[0].brandName} ${
              selectedOptionRows[0].productName
            } ${
              selectedOptionRows?.length > 1
                ? `외 ${selectedOptionRows?.length - 1}건`
                : ''
            }
            □ 주문총액 : ${
              orderInfo?.deliveryPrice > 0
                ? `(배송비 포함 ${orderInfo?.deliveryPrice?.toLocaleString()}원) ` +
                  (
                    orderInfo.totalPrice + orderInfo?.deliveryPrice
                  ).toLocaleString()
                : orderInfo?.totalPrice?.toLocaleString()
            }원\n
            ■ 배송정보
            □ 받으시는 분 : ${orderInfo?.name}
            □ 휴대폰 : ${orderInfo?.phone}
            □ 주소 : ${orderInfo?.address} ${
              Object.prototype.hasOwnProperty.call(
                orderInfo,
                'addressDetail',
              ) && orderInfo?.addressDetail !== null
                ? orderInfo?.addressDetail
                : ''
            }
            `)
      ) {
        if (paymentType === 'vbank') {
          payByVbank()
        }
      }
    }
  }

  const payByVbank = async () => {
    let userId = orderInfo?.createdBy
    // eslint-disable-next-line eqeqeq
    if (orderInfo?.createdBy == null) {
      const userParam = {
        name: orderInfo.name,
        provider: 'guest',
        phone: orderInfo.phone,
      }
      const userRes = await customerApi.createGuestUser(userParam, user.id)
      if (userRes.data.code === 200) {
        userId = userRes.data.result.id
      } else {
        throw userRes.data.msg
      }
    }
    if (userId) {
      let sendOrderDetailList = []
      let totalPoint = 0

      // 선택한 옵션에서 detail 생성
      for (const orderDetail of selectedOptionRows) {
        // 포인트 적립
        let point = 0
        if (orderDetail.savingPoint !== null && orderDetail.savingPoint !== 0) {
          point =
            orderDetail.savingPointType === 'PERCENT'
              ? ((orderDetail.price2 * orderDetail.savingPoint) / 100).toFixed()
              : orderDetail.savingPoint
          point = point * orderDetail.quantity
          totalPoint += point * orderDetail.quantity
        }
        const sendOrderDetail = {
          orderDetailStatus: 'ready',
          productId: orderDetail.productId,
          quantity: orderDetail.quantity,
          price: orderDetail.price2,
          totalPrice: orderDetail.price2 * orderDetail.quantity,
          earnPoint: point,
        }
        if (orderDetail.hasOwnProperty('optionId')) {
          sendOrderDetail['optionId'] = orderDetail.optionId
        }
        sendOrderDetailList.push(sendOrderDetail)
      }
      const orderParam = {
        totalOrder: {
          ...orderInfo,
          totalPrice:
            orderInfo?.deliveryPrice > 0
              ? orderInfo.totalPrice + orderInfo?.deliveryPrice
              : orderInfo.totalPrice,
          orderStatus: 'ready',
          earnPoint: totalPoint,
          isManual: true,
          isDeposit: true,
          createdBy: userId,
        },
        orderDetailList: sendOrderDetailList,
      }

      if (selectOptions.cashReceiptType !== null) {
        orderParam.totalOrder['cashReceiptType'] = selectOptions.cashReceiptType
      }
      const orderRes = await orderApi.orderCreate(orderParam, user.id)
      if (orderRes.data.code === 200) {
        const orderId = orderRes.data.result
        IamPortVbank(orderId)
      }
    }
  }

  const IamPortVbank = (orderId) => {
    IMP.request_pay(
      {
        channelKey: process.env.REACT_APP_IMP_CHANNEL_KEY,
        pg: 'html5_inicis.MOI6671119', //테스트 시 html5_inicis.INIpayTest 기재
        // pg: 'html5_inicis.INIpayTest',
        pay_method: 'vbank',
        // pay_method: 'tosspay',
        // pay_method: 'naverpay',
        merchant_uid: `SUG-${orderId}`, //상점에서 생성한 고유 주문번호
        name: `${selectedOptionRows[0].brandName} ${
          selectedOptionRows[0].productName
        } ${
          selectedOptionRows?.length > 1
            ? `외 ${selectedOptionRows?.length - 1}건`
            : ''
        }`,
        amount: `${
          orderInfo?.deliveryPrice > 0
            ? orderInfo.totalPrice + orderInfo?.deliveryPrice
            : orderInfo.totalPrice
        }`,
        buyer_email: '',
        buyer_name: `${orderInfo.name}`,
        buyer_tel: `${orderInfo.phone}`,
        buyer_addr: `${orderInfo.address} ${
          Object.prototype.hasOwnProperty.call(orderInfo, 'addressDetail') &&
          orderInfo.addressDetail !== null
            ? orderInfo.addressDetail
            : ''
        }`,
        buyer_postcode: `${orderInfo.postalCode}`,
      },
      function (rsp) {
        // callback 로직
        if (rsp.success) {
          alert('가상 계좌 생성 성공')
          console.log(rsp)
          navigate(`/order/search`)
        } else {
          alert('가상 계좌 생성 실패')
          console.log('계좌 에러 실패 :', rsp)
        }
      },
    )
  }

  return (
    <>
      <ContentHeader title="전화 주문" />
      <div
        className={`${styles['product-register-wrap']} ${styles['order-component-wrap']}`}
      >
        {/* 주문정보 */}
        <div
          className={`${styles['order-component-body']}`}
          style={{ minWidth: '640px' }}
        >
          <Row className={`${styles['order-component-box']}`}>
            <div className={`${styles['order-component-title-div']}`}>
              <h2 className={`${styles['order-component-title']}`}>주문정보</h2>
            </div>
            <div className={`${styles['order-component-info']}`}>
              {/* 주문 상품*/}
              <div className={`${styles['order-component-each']}`}>
                <h3 className={`${styles['order-each-title']}`}>
                  주문 상품
                  <span className={`${styles['title-required']}`}>*</span>
                </h3>
                <Col className={`${styles['order-component-each-col']}`}>
                  {/* 상품 검색 */}
                  <ProductSearchComponent
                    searchOptions={searchOptions}
                    handleChange={handleChange}
                    handleProductSearch={handleProductSearch}
                    handleProductRowEvent={handleProductRowEvent}
                    tableOnChange={tableOnChange}
                    orderType={orderType}
                    orderBy={orderBy}
                    orderInfo={orderInfo}
                    setOrderInfo={setOrderInfo}
                    selectedProductRows={selectedProductRows}
                    setSelectedProductRows={setSelectedProductRows}
                    selectedProductRowKeys={selectedProductRowKeys}
                    setSelectedProductRowKeys={setSelectedProductRowKeys}
                  />
                  {/* 옵션 설정 */}
                  <ProductOptionComponent
                    optionRowSelection={optionRowSelection}
                    optionList={optionList}
                    handleOptionRowEvent={handleOptionRowEvent}
                    selectedProductRowKeys={selectedProductRowKeys}
                  />
                </Col>
              </div>

              {/* 배송비, 총 금액 */}
              <ProductPriceComponent
                sellerList={sellerList}
                orderInfo={orderInfo}
                setOrderInfo={setOrderInfo}
                selectedOptionRows={selectedOptionRows}
                setSelectedOptionRows={setSelectedOptionRows}
                selectedOptionRowKeys={selectedOptionRowKeys}
                setSelectedOptionRowKeys={setSelectedOptionRowKeys}
              />

              {/* 주문자 정보 */}
              {/* 받는 분, 핸드폰 번호, 배송지, 배송 요청사항, 입금자명, 현금영수증*/}
              <ProductBuyerComponent
                orderInfo={orderInfo}
                setOrderInfo={setOrderInfo}
                handleChange={handleChange}
                paymentTypeOption={paymentTypeOption}
                paymentType={paymentType}
                setPaymentType={setPaymentType}
                selectOptions={selectOptions}
                setSelectOptions={setSelectOptions}
                cashReceiptTypeItems={cashReceiptTypeItems}
              />

              {/* 주문생성/취소 버튼 */}
              <div
                className={`${styles['order-component-each']} ${styles['save-button-group']}`}
              >
                <Button
                  className={`${styles['product-register-button']} ${styles.save}`}
                  onClick={handlePurchase}
                  loading={isLoading}
                >
                  {isLoading ? null : '주문생성'}
                </Button>
                <Button
                  className={`${styles['product-register-button']} ${styles.cancel}`}
                  onClick={cancelBtnClick}
                >
                  취소
                </Button>
              </div>
            </div>
          </Row>
        </div>

        {/* 상담 내용 & FAQ */}
        <div
          className={`${styles['order-component-body']} ${styles.flexColumn}`}
          style={{
            minWidth: '50%',
          }}
        >
          {/* 상담내용 */}
          <Row className={`${styles['order-component-box']}`}>
            <div className={`${styles['order-component-title-div']}`}>
              <h2 className={`${styles['order-component-title']}`}>
                {user && user.id === 1 ? '상담내용' : '메모'}
              </h2>
            </div>
            <div className={`${styles['order-component-info']}`}>
              <div className={`${styles['order-component-each']}`}>
                <div className={`${styles['order-component-each-detail']}`}>
                  <Row
                    align="top"
                    justify={'space-between'}
                    style={{ rowGap: '8px' }}
                  >
                    <Input.TextArea
                      className={`${styles['order-create-memo-wrap']}`}
                      name="memo"
                      value={orderInfo.memo}
                      onChange={handleChange}
                      placeholder={
                        user && user.id === 1
                          ? `안녕하세요. 슈가코치입니다. 무엇을 도와드릴까요?
                        1) 고객님이라고 지칭할 것
                        2) 고객보다 전화를 먼저 끊지 말 것
                        3) 전문적인 질문 시 모르는 것이 있다면 약사 확인 후 안내드린다고 안내하기
                        4) 주문수량에 대해 3+1, 7+4 등 혜택 안내하기
                        5) 연락처는 핸드폰 발신자표시를 통해 확인하기
                        6) 주문생성 후 고객에게 메시지 확인 요청하기
                        `
                          : '해당 주문에 관한 간단한 내용을 작성해보세요.'
                      }
                      style={{
                        minHeight: '180px',
                        height: '100%',
                      }}
                    />
                  </Row>
                </div>
              </div>
            </div>
          </Row>
        </div>
      </div>
    </>
  )
}

export default OrderTelPage
